/* eslint-disable no-underscore-dangle */
export const _timezone = [
  { id: 1, useDaylightTime: 0, value: -12, name: '(GMT-12:00) International Date Line West', zone: 'Etc/GMT-12' },
  { id: 2, useDaylightTime: 0, value: -11, name: '(GMT-11:00) Midway Island, Samoa', zone: 'Pacific/Samoa' },
  { id: 3, useDaylightTime: 0, value: -10, name: '(GMT-10:00) Hawaii', zone: 'US/Hawaii' },
  { id: 4, useDaylightTime: 1, value: -9, name: '(GMT-09:00) Alaska', zone: 'US/Alaska' },
  { id: 5, useDaylightTime: 1, value: -8, name: '(GMT-08:00) Pacific Time (US & Canada)', zone: 'Canada/Pacific' },
  { id: 6, useDaylightTime: 1, value: -8, name: '(GMT-08:00) Tijuana, Baja California', zone: 'America/Tijuana' },
  { id: 7, useDaylightTime: 0, value: -7, name: '(GMT-07:00) Arizona', zone: 'US/Arizona' },
  { id: 8, useDaylightTime: 1, value: -7, name: '(GMT-07:00) Chihuahua, La Paz, Mazatlan', zone: 'America/Chihuahua' },
  { id: 9, useDaylightTime: 1, value: -7, name: '(GMT-07:00) Mountain Time (US & Canada)', zone: 'US/Mountain' },
  { id: 10, useDaylightTime: 0, value: -6, name: '(GMT-06:00) Central America', zone: 'US/Central' },
  { id: 11, useDaylightTime: 1, value: -6, name: '(GMT-06:00) Central Time (US & Canada)', zone: 'US/Central' },
  {
    id: 12,
    useDaylightTime: 1,
    value: -6,
    name: '(GMT-06:00) Guadalajara, Mexico City, Monterrey',
    zone: 'Canada/Central',
  },
  { id: 13, useDaylightTime: 0, value: -6, name: '(GMT-06:00) Saskatchewan', zone: 'Canada/Saskatchewan' },
  {
    id: 14,
    useDaylightTime: 0,
    value: -5,
    name: '(GMT-05:00) Bogota, Lima, Quito, Rio Branco',
    zone: 'America/Bogota',
  },
  { id: 15, useDaylightTime: 1, value: -5, name: '(GMT-05:00) Eastern Time (US & Canada)', zone: 'US/Eastern' },
  { id: 16, useDaylightTime: 1, value: -5, name: '(GMT-05:00) Indiana (East)', zone: 'US/East-Indiana' },
  { id: 17, useDaylightTime: 1, value: -4, name: '(GMT-04:00) Atlantic Time (Canada)', zone: 'Canada/Atlantic' },
  { id: 18, useDaylightTime: 0, value: -4, name: '(GMT-04:00) Caracas, La Paz', zone: 'America/Caracas' },
  { id: 19, useDaylightTime: 0, value: -4, name: '(GMT-04:00) Manaus', zone: 'America/Manaus' },
  { id: 20, useDaylightTime: 1, value: -4, name: '(GMT-04:00) Santiago', zone: 'America/Santiago' },
  { id: 21, useDaylightTime: 1, value: -3.5, name: '(GMT-03:30) Newfoundland', zone: 'Canada/Newfoundland' },
  { id: 22, useDaylightTime: 1, value: -3, name: '(GMT-03:00) Brasilia', zone: 'Brazil/DeNoronha' },
  {
    id: 23,
    useDaylightTime: 0,
    value: -3,
    name: '(GMT-03:00) Buenos Aires, Georgetown',
    zone: 'America/Argentina/Buenos_Aires',
  },
  { id: 24, useDaylightTime: 1, value: -3, name: '(GMT-03:00) Greenland', zone: 'Etc/GMT-3' },
  { id: 25, useDaylightTime: 1, value: -3, name: '(GMT-03:00) Montevideo', zone: 'America/Montevideo' },
  { id: 26, useDaylightTime: 1, value: -2, name: '(GMT-02:00) Mid-Atlantic', zone: 'Etc/GMT-2' },
  { id: 27, useDaylightTime: 0, value: -1, name: '(GMT-01:00) Cape Verde Is.', zone: 'Atlantic/Cape_Verde' },
  { id: 28, useDaylightTime: 1, value: -1, name: '(GMT-01:00) Azores', zone: 'Atlantic/Azores' },
  {
    id: 29,
    useDaylightTime: 0,
    value: 0,
    name: '(GMT+00:00) Casablanca, Monrovia, Reykjavik',
    zone: 'Africa/Casablanca',
  },
  {
    id: 30,
    useDaylightTime: 1,
    value: 0,
    name: '(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
    zone: 'Europe/London',
  },
  {
    id: 31,
    useDaylightTime: 1,
    value: 1,
    name: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    zone: 'Europe/Amsterdam',
  },
  {
    id: 32,
    useDaylightTime: 1,
    value: 1,
    name: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    zone: 'Europe/Belgrade',
  },
  {
    id: 33,
    useDaylightTime: 1,
    value: 1,
    name: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
    zone: 'Europe/Brussels',
  },
  { id: 34, useDaylightTime: 1, value: 1, name: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb', zone: 'Europe/Warsaw' },
  { id: 35, useDaylightTime: 1, value: 1, name: '(GMT+01:00) West Central Africa', zone: 'Africa/Libreville' },
  { id: 36, useDaylightTime: 1, value: 2, name: '(GMT+02:00) Amman', zone: 'Asia/Amman' },
  { id: 37, useDaylightTime: 1, value: 2, name: '(GMT+02:00) Athens, Bucharest, Istanbul', zone: 'Europe/Athens' },
  { id: 38, useDaylightTime: 1, value: 2, name: '(GMT+02:00) Beirut', zone: 'Asia/Beirut' },
  { id: 39, useDaylightTime: 1, value: 2, name: '(GMT+02:00) Cairo', zone: 'Africa/Cairo' },
  { id: 40, useDaylightTime: 0, value: 2, name: '(GMT+02:00) Harare, Pretoria', zone: 'Africa/Harare' },
  {
    id: 41,
    useDaylightTime: 1,
    value: 2,
    name: '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    zone: 'Europe/Helsinki',
  },
  { id: 42, useDaylightTime: 1, value: 2, name: '(GMT+02:00) Jerusalem', zone: 'Asia/Jerusalem' },
  { id: 43, useDaylightTime: 1, value: 2, name: '(GMT+02:00) Minsk', zone: 'Europe/Minsk' },
  { id: 44, useDaylightTime: 1, value: 2, name: '(GMT+02:00) Windhoek', zone: 'Africa/Windhoek' },
  { id: 45, useDaylightTime: 0, value: 3, name: '(GMT+03:00) Kuwait, Riyadh, Baghdad', zone: 'Asia/Kuwait' },
  {
    id: 46,
    useDaylightTime: 1,
    value: 3,
    name: '(GMT+03:00) Moscow, St. Petersburg, Volgograd',
    zone: 'Europe/Moscow',
  },
  { id: 47, useDaylightTime: 0, value: 3, name: '(GMT+03:00) Nairobi', zone: 'Africa/Nairobi' },
  { id: 48, useDaylightTime: 0, value: 3, name: '(GMT+03:00) Tbilisi', zone: 'Asia/Tbilisi' },
  { id: 49, useDaylightTime: 1, value: 3.5, name: '(GMT+03:30) Tehran', zone: 'Asia/Tehran' },
  { id: 50, useDaylightTime: 0, value: 4, name: '(GMT+04:00) Abu Dhabi, Muscat', zone: 'Asia/Muscat' },
  { id: 51, useDaylightTime: 1, value: 4, name: '(GMT+04:00) Baku', zone: 'Asia/Baku' },
  { id: 52, useDaylightTime: 1, value: 4, name: '(GMT+04:00) Yerevan', zone: 'Asia/Yerevan' },
  { id: 53, useDaylightTime: 0, value: 4.5, name: '(GMT+04:30) Kabul', zone: 'Asia/Kabul' },
  { id: 54, useDaylightTime: 1, value: 5, name: '(GMT+05:00) Yekaterinburg', zone: 'Asia/Yekaterinburg' },
  { id: 55, useDaylightTime: 0, value: 5, name: '(GMT+05:00) Islamabad, Karachi, Tashkent', zone: 'Asia/Karachi' },
  {
    id: 56,
    useDaylightTime: 0,
    value: 5.5,
    name: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    zone: 'Asia/Kolkata',
  },
  { id: 57, useDaylightTime: 0, value: 5.75, name: '(GMT+05:45) Kathmandu', zone: 'Asia/Kathmandu' },
  { id: 58, useDaylightTime: 1, value: 6, name: '(GMT+06:00) Almaty, Novosibirsk', zone: 'Asia/Almaty' },
  { id: 59, useDaylightTime: 0, value: 6, name: '(GMT+06:00) Astana, Dhaka', zone: 'Asia/Dhaka' },
  { id: 60, useDaylightTime: 0, value: 6.5, name: '(GMT+06:30) Yangon (Rangoon)', zone: 'Asia/Rangoon' },
  { id: 61, useDaylightTime: 0, value: 7, name: '(GMT+07:00) Bangkok, Hanoi, Jakarta', zone: 'Asia/Bangkok' },
  { id: 62, useDaylightTime: 1, value: 7, name: '(GMT+07:00) Krasnoyarsk', zone: 'Asia/Krasnoyarsk' },
  {
    id: 63,
    useDaylightTime: 0,
    value: 8,
    name: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    zone: 'Asia/Chongqing',
  },
  { id: 64, useDaylightTime: 0, value: 8, name: '(GMT+08:00) Kuala Lumpur, Singapore', zone: 'Asia/Kuala_Lumpur' },
  { id: 65, useDaylightTime: 0, value: 8, name: '(GMT+08:00) Irkutsk, Ulaan Bataar', zone: 'Asia/Irkutsk' },
  { id: 66, useDaylightTime: 0, value: 8, name: '(GMT+08:00) Perth', zone: 'Australia/Perth' },
  { id: 67, useDaylightTime: 0, value: 8, name: '(GMT+08:00) Taipei', zone: 'Asia/Taipei' },
  { id: 68, useDaylightTime: 0, value: 9, name: '(GMT+09:00) Osaka, Sapporo, Tokyo', zone: 'Asia/Tokyo' },
  { id: 69, useDaylightTime: 0, value: 9, name: '(GMT+09:00) Seoul', zone: 'Asia/Seoul' },
  { id: 70, useDaylightTime: 1, value: 9, name: '(GMT+09:00) Yakutsk', zone: 'Asia/Yakutsk' },
  { id: 71, useDaylightTime: 0, value: 9.5, name: '(GMT+09:30) Adelaide', zone: 'Australia/Adelaide' },
  { id: 72, useDaylightTime: 0, value: 9.5, name: '(GMT+09:30) Darwin', zone: 'Australia/Darwin' },
  { id: 73, useDaylightTime: 0, value: 10, name: '(GMT+10:00) Brisbane', zone: 'Australia/Brisbane' },
  {
    id: 74,
    useDaylightTime: 1,
    value: 10,
    name: '(GMT+10:00) Canberra, Melbourne, Sydney',
    zone: 'Australia/Melbourne',
  },
  { id: 75, useDaylightTime: 1, value: 10, name: '(GMT+10:00) Hobart', zone: 'Australia/Hobart' },
  { id: 76, useDaylightTime: 0, value: 10, name: '(GMT+10:00) Guam, Port Moresby', zone: 'Pacific/Guam' },
  { id: 77, useDaylightTime: 1, value: 10, name: '(GMT+10:00) Vladivostok', zone: 'Asia/Vladivostok' },
  {
    id: 78,
    useDaylightTime: 1,
    value: 11,
    name: '(GMT+11:00) Magadan, Solomon Is., New Caledonia',
    zone: 'Asia/Magadan',
  },
  { id: 79, useDaylightTime: 1, value: 12, name: '(GMT+12:00) Auckland, Wellington', zone: 'Pacific/Auckland' },
  { id: 80, useDaylightTime: 0, value: 12, name: '(GMT+12:00) Fiji, Kamchatka, Marshall Is.', zone: 'Pacific/Fiji' },
];

export const _CALCULATION_CONTROL_LIST = [
  'number_input',
  'text_input',
  'short_text',
  'labeled_input',
  'prepended_text',
  'appended_text',
  'select_basic',
  'radio_buttons',
  'inline_radios',
  'checkboxes',
  'inline_checkboxes',
  'star_rating',
  'heart_rating',
  'scale_rating',
  'datetime',
  'duration',
  'image_choice',
  'table_field',
  'matrix_rating',
];

const _CALCULATION_CONTROL_RESULT_LIST = [
  'text_input',
  'labeled_input',
  'number_input',
  'stripe',
  'flutterwave',
  'paypal',
  'paystack',
  'table_field',
  'short_text',
  'prepended_text',
  'appended_text',
];

const _STRIPE_METADATA_CONTROL_LIST = [
  'text_input',
  'short_text',
  'email',
  'number_input',
  'phone',
  'labeled_input',
  'website',
  'datetime',
  'lookup',
  'select_basic',
  'select_multiple',
  'checkboxes',
  'inline_checkboxes',
  'radio_buttons',
  'inline_radios',
  'image_choice',
  'prepended_text',
  'appended_text',
];
export const fplsConstants = {
  timezone: _timezone,
  CALCULATION_CONTROL_LIST: _CALCULATION_CONTROL_LIST,
  CALCULATION_CONTROL_RESULT_LIST: _CALCULATION_CONTROL_RESULT_LIST,
  STRIPE_METADATA_CONTROL_LIST: _STRIPE_METADATA_CONTROL_LIST,
};
